export const italian = {
  seo: {
    title: 'Case: Ristorante Il Municipio | Bistroo',
    description: 'How Bistroo helped the Italian restaurant Il Municipio manage busy periods and grow online.',
  },
  hero: {
    title: 'How Bistroo helped our Italian restaurant handle the rush and grow',
    description:
      "Ristorante Il Municipio is a renowned Italian restaurant located in Twente, specializing in authentic pizzas and pastas. Their craftsmanship was recognized when they secured 1st place at the 2025 Dutch Pizza Baking Championships at Horecava.",
  },
  testimonials: {
    1: {
      text: '"Bistroo really thought along with us and offered solutions that matched our needs and growing ambitions. New opportunities were quickly developed and implemented, leading to a seamless collaboration and an improvement in our customer service."',
      name: 'Roberta',
      job_title: 'Hostess',
    },
    2: {
      text: '"Since switching to Bistroo, we no longer have to take phone orders, which saves us valuable time and gives us more room to focus on serving our customers."',
      name: 'Edwin ter Haar',
      job_title: 'Owner',
    },
  },
  challenge: {
    paragraph: {
      title: 'New solutions and opportunities',
      text: 'The restaurant is known for its passion for high-quality ingredients and traditional Italian cuisine. Il Municipio has been working with Bistroo for over 2 years and shares the challenges they faced before the partnership and the solutions Bistroo provides.',
    },
    paragraph_2: {
      title: 'The challenge',
      bullets: {
        1: 'During busy hours, Ristorante Il Municipio could become overwhelmed with orders, causing the restaurant staff and customers to wait longer.',
        2: 'Taking phone orders consumed a lot of staff time and sometimes led to errors or misunderstandings.',
        3: 'As a rapidly changing and growing business, Ristorante Il Municipio needed a flexible solution that could scale with their evolving needs.',
        4: '',
      },
    },
  },
  solution: {
    title: 'The solution',
    checklist: {
      1: "Bistroo's online ordering solution gave Ristorante Il Municipio the ability to send digital order confirmations to customers. Customers could check their orders for errors, improving accuracy and satisfaction.",
      2: 'By switching to Bistroo, the staff of Ristorante Il Municipio no longer had to take phone orders, saving valuable time they can now spend preparing delicious dishes and providing excellent service to customers.',
      3: 'Bistroo worked alongside Ristorante Il Municipio and offered solutions that matched their changing needs and growing ambitions. New ideas were quickly developed and implemented, resulting in seamless collaboration and better customer service.',
      4: 'Bistroo was always available to support Ristorante Il Municipio, regardless of the time. This continuous support gave the restaurant peace of mind and confidence in their online ordering process.',
    },
  },
  conclusion: {
    title: 'The conclusion',
    text: {
      1: "Thanks to Bistroo's online ordering solution, Ristorante Il Municipio was able to not only improve their operational efficiency but also enhance customer satisfaction and capitalize on growth opportunities. The restaurant especially appreciated the digital confirmation system and the time saved by eliminating phone orders.",
      2: 'As a partner that is available 24/7 and adapts to the needs of the restaurant, Ristorante Il Municipio highly recommends Bistroo to other hospitality businesses looking for a flexible and efficient online ordering solution.',
    },
  },
}
